import { PendoEvents, getUtmSource, removeUtmSourceFromUrl, usePendo } from '@local/shared';

export const useProcessUtmSource = () => {
    const pendo = usePendo();
    return async (hasAccess: boolean) => {
        const utmSource = getUtmSource();
        if (utmSource) {
            // If utmSource is present in the URL params, we need to track it in Pendo
            pendo.trackEvent(PendoEvents.CaseExternalLinkNavigate, {
                hasAccess,
                utmSource: utmSource!,
            });
            removeUtmSourceFromUrl();
            return new Promise<void>(resolve => {
                pendo.flushEvents();
                setTimeout(() => resolve(), 2000); // Give some time for Pendo to send the event before resolving
            });
        }
    };
};
